import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TopBanner } from './components/TopBanner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { QuickActions } from './components/QuickActions';
import { ProductGrid } from './components/ProductGrid';
import { AdviceSection } from './components/AdviceSection';
import { Footer } from './components/Footer';
import { CartProvider } from './context/CartContext';
// Pages
import { Prescriptions } from './pages/Prescriptions';
import { OTCProducts } from './pages/OTCProducts';
import { Services } from './pages/Services';
import { Locations } from './pages/Locations';
import { Cart } from './pages/Cart';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { HIPAA } from './pages/HIPAA';
function Home() {
  return <>
      <Hero data-id="element-0" />
      <QuickActions data-id="element-1" />
      <ProductGrid data-id="element-2" />
      <AdviceSection data-id="element-3" />
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-4">
      <CartProvider data-id="element-5">
        <div className="min-h-screen flex flex-col font-sans selection:bg-clinical-blue selection:text-white bg-white" data-id="element-6">
          <header className="sticky top-0 z-50 w-full" data-id="element-7">
            <TopBanner data-id="element-8" />
            <Navbar data-id="element-9" />
          </header>
          <main className="flex-grow" data-id="element-10">
            <Routes data-id="element-11">
              <Route path="/" element={<Home data-id="element-13" />} data-id="element-12" />
              <Route path="/prescriptions" element={<Prescriptions data-id="element-15" />} data-id="element-14" />
              <Route path="/otc-products/:storeId" element={<OTCProducts data-id="element-17" />} data-id="element-16" />
              <Route path="/otc-products" element={<OTCProducts data-id="element-19" />} data-id="element-18" />
              <Route path="/services" element={<Services data-id="element-21" />} data-id="element-20" />
              <Route path="/locations" element={<Locations data-id="element-23" />} data-id="element-22" />
              <Route path="/cart" element={<Cart data-id="element-25" />} data-id="element-24" />
              <Route path="/privacy" element={<Privacy data-id="element-27" />} data-id="element-26" />
              <Route path="/terms" element={<Terms data-id="element-29" />} data-id="element-28" />
              <Route path="/hipaa" element={<HIPAA data-id="element-31" />} data-id="element-30" />
            </Routes>
          </main>
          <Footer data-id="element-32" />
        </div>
      </CartProvider>
    </BrowserRouter>;
}